import type { CombinedError } from '@urql/vue'
import * as Sentry from '@sentry/nuxt'

export const useHandleError = (errors: MaybeRef<CombinedError | undefined>, fatal?: boolean) => {
  const { notify } = useNotification()
  const { $i18n } = useNuxtApp()

  watch(
    () => unref(errors),
    (errors) => {
      if (!errors) return

      Sentry.captureException(errors)

      console.error('Captured error', {
        errors,
        gql: errors.graphQLErrors,
      })

      const message = errors.graphQLErrors ? readGqlError(errors) : [errors.message]

      if (fatal) {
        throw createError({
          fatal: true,
          statusCode: 500,
          message: $i18n.t(message[0] || 'errors.system.internal'),
          stack:
              errors.graphQLErrors
                .map((e: any) => e?.debugMessage || e?.message || e)
                .map(e => $i18n.t(e))
                .join('\n\n')
                + '\n\n'
                + Object.values(errors.graphQLErrors[0]?.extensions?.validation ?? {})
                  .map(e => e[0])
                  .map(e => $i18n.t(e))
                  .join('\n\n'),
        })
      } else {
        message.forEach(message => notify({
          type: 'error',
          title: $i18n.t('errors.system.toast_title'),
          text: $i18n.t(message || 'errors.system.internal'),
        }))
      }
    },
    {
      immediate: true,
    },
  )
}
